import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, LoadingController, Platform } from '@ionic/angular';
import { CrudService } from 'src/app/services/crud.service';
import { ResponseAPI, User } from 'src/models/user.model';
import { UtilService } from 'src/app/services/util.service';
import { loadingProps } from 'src/utils/util.functions';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-finally-race',
    templateUrl: './finally-race.page.html',
    styleUrls: ['./finally-race.page.scss'],
    standalone: false
})
export class FinallyRacePage implements OnInit {
  saldoCorrida: any = {};
  saldo: any = {};
  user: User;
  race: any;
  constructor(
    private modalCtrl: ModalController,
    public navCtrl: NavController,
    public crud: CrudService,
    private util: UtilService,
    private auth: AuthService,
    private loadingCtrl: LoadingController,
    private platform: Platform
  ) {
    this.user = this.auth.user;
  }

  ngOnInit() {
    this.saldoCorrida = JSON.parse(localStorage.getItem("saldoCorrida"));
    this.race = JSON.parse(localStorage.getItem("currentRace"));
    localStorage.removeItem(`notified_${this.race.id}`);
    this.crud
      .getData("Corrida/saldo", null)
      .subscribe(
        (response: ResponseAPI) => {
          if (response.success) {
            this.saldo = response.data;
          }
        },
        error => {
          this.util.showToast("An error occured");
        }
      );
  }
  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(loadingProps);
    return await loading.present();
  }
  async payPlatform() {
    await this.showLoading();
    this.crud
      .getData("motorista/realizar-pagamento")
      .subscribe(
        async (response: string) => {
          if (response === "Ok") {
            this.loadingCtrl.dismiss();
            await this.util.openCashApp();
          }
          this.loadingCtrl.dismiss();
        },
        error => {
          this.loadingCtrl.dismiss();
          this.util.showToast(
            "Error retrieving data. Please check your internet connection"
          );
        }
      );
  }
  close() {
    this.modalCtrl.dismiss();
  }

  backQueue(): void {
    this.close();
    this.navCtrl.navigateForward('driver/queue');
  }
}
